<template>
    <p>{{title}}</p>
    <div class="select-wrapper">
      <select v-model="selectValue" :disabled="disabled">
        <option v-for="value in values" :key="value.value" :value="value.value">{{ value.name }}</option>
      </select>
    </div>
</template>

<script>


export default {

  data:function (){
    return {
      gridForSelect:'col-lg-3',
      disabled:false
    }
  },
  name: "SelectFilter",
  props: {
    property:{
      type:String,
      required:false
    },
    title:{
      type:String,
      required:false
    },
  },
  computed: {
    values () {
      return this.$store.getters.filterValue(this.property);
    },
    selectValue:{
      get:function () {
        let propertyValue = this.$store.getters.selectedValue(this.property);

        if (typeof propertyValue == 'undefined'){
          const propertyValues = this.$store.getters.filterValue(this.property);
          let value = 0;
          if (propertyValues.length){
            value = propertyValues[0].value;
          }
          this.$store.dispatch('select',{name:this.property,value:value});
          return value;
        }

        return propertyValue
      },
      set:function (newValue) {
        this.$store.dispatch('select',{name:this.property,value:newValue});
      }
    }
  }
}
</script>

